import { Injectable } from '@angular/core';
import { SuggestionService } from './suggestion.service';
import { DatasourceDomain } from '@mode/shared/contract-common';
import { DataIndexClientService } from '@mode/queries/schemas/data-access';
import columnHelpers from './column-suggestion-helper';
import { QueryOptions } from '@mode/shared/data-access-algolia';
import { SearchClientService } from '@mode/algolia/domain';
import { SuggestionObservabilityService } from '@mode/shared/util-observability';
import { parseMatchTables } from './table-provider';

@Injectable()
export class DataIndexSuggestionService implements SuggestionService {
  constructor(
    private _dataIndexClient: DataIndexClientService,
    private _searchClientService: SearchClientService,
    private _o11yService: SuggestionObservabilityService
  ) {}

  async getTables(
    datasource: DatasourceDomain.Datasource,
    opts: QueryOptions<any>,
    isCompletingDefinition: boolean
  ): Promise<AceAjax.Completion[]> {
    return this._dataIndexClient
      .search(datasource.token, opts)
      .then((results) => {
        return this._searchClientService.getClientResponse(
          { ...opts, dataSourceIsPublic: datasource.public },
          { results }
        );
      })
      .then((queryResults) => {
        return parseMatchTables(datasource, queryResults, isCompletingDefinition);
      });
  }

  async getColumns(datasource: DatasourceDomain.Datasource, opts: QueryOptions<'table' | 'dataSourceTable'>) {
    return this._dataIndexClient
      .search(datasource.token, opts)
      .then((results) => results.flatMap((r) => r.hits).filter((hit) => 'columns' in hit)[0])
      .then((table) => columnHelpers.getColumnsInTable(table));
  }

  async getDefinition(opts: QueryOptions<'definition'>) {
    const dataSourceToken = typeof opts.filters === 'string' ? opts.filters.split(',')[0].split('_')[1] : 'INVALID';
    return this._dataIndexClient
      .search(dataSourceToken, {
        ...opts,
        attrsToSearchIn: { definition: ['name'] },
        attrsToRetrieve: ['name', 'source'],
      })
      .then((results) => results[0].hits[0]);
  }
}
